var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"fluid":"","fill-height":""}},[_c('v-container',{staticClass:"d-flex justify-center align-center",staticStyle:{"min-width":"100% !important","height":"100vh"}},[_c('Autenticacion')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }